import { render, staticRenderFns } from "./InfoCompraSegura.vue?vue&type=template&id=9576b30a&"
var script = {}
import style0 from "./InfoCompraSegura.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports